(function () {
    'use strict';

    angular
        .module('ib-header-collapse-module')
        .directive('headerCollapse', headerCollapse);

    headerCollapse.$inject = ['$document', '$rootScope'];
    function headerCollapse($document, $rootScope) {
        var auxCollapse, info;
        $document.on('click', function (event) {
            auxCollapse = this.querySelector('.ib-header-ancilliares .collapse.in');
            info = this.querySelector('.delete-ancillarie');
            if (event.target.closest('.collapse.in') === null && auxCollapse !== null && info ===null) {
                $rootScope.$emit('closeCollapseHeader', {});
            }
        });
        return {
            restrict: 'AE',
            controller: 'IbHeaderCollapseController',
            link: link
        };
        function link(scope, elem, attrs) {

        }
    }

})();
